import { type LandingPageNamespace } from '../en-US/landingPage';

export const landingPage = {
  get_started: 'Comienza',
  header: 'Donde los Miembros de Medi-Share se Reúnen Para Orar',
  prayerstream: 'PrayerStream',
  subheader: `PrayerStream es más que una charla: es un punto de conexión significativo para los miembros de Medi-Share.
Esta experiencia única crea vínculos de fe y muestra la bondad y el cuidado de Dios por su pueblo.`,
} as const satisfies LandingPageNamespace;
